// Rich Text aus Close (Notizen, Anrufnotizen, Rich-Text-Felder) sicher anzeigen und einfachen Text in HTML wandeln.

const ERLAUBT = new Set([
  "P", "BR", "B", "STRONG", "I", "EM", "U", "S", "STRIKE", "DEL", "UL", "OL", "LI", "A", "BLOCKQUOTE",
  "H1", "H2", "H3", "H4", "SPAN", "DIV", "CODE", "PRE", "HR", "TABLE", "THEAD", "TBODY", "TR", "TD", "TH",
  "SUB", "SUP", "MARK",
]);
const ENTFERNEN = new Set([
  "SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "TEMPLATE", "NOSCRIPT", "SVG", "MATH", "FORM", "INPUT",
  "BUTTON", "TEXTAREA", "SELECT", "IMG", "VIDEO", "AUDIO", "LINK", "META", "HEAD", "TITLE", "BASE", "FRAME",
]);

function reinigen(el: Element): void {
  for (const kind of Array.from(el.children)) {
    if (ENTFERNEN.has(kind.tagName)) {
      kind.remove();
      continue;
    }
    reinigen(kind);
    if (!ERLAUBT.has(kind.tagName)) {
      kind.replaceWith(...Array.from(kind.childNodes));
      continue;
    }
    for (const attr of Array.from(kind.attributes)) {
      const ok = kind.tagName === "A" && attr.name === "href" && /^(https?:|mailto:|tel:)/i.test(attr.value.trim());
      if (!ok) kind.removeAttribute(attr.name);
    }
    if (kind.tagName === "A") {
      kind.setAttribute("target", "_blank");
      kind.setAttribute("rel", "noopener noreferrer");
    }
  }
}

const cache = new Map<string, string>();

/** HTML aus Close auf eine sichere Teilmenge reduzieren (keine Skripte, Stile, Bilder, Ereignis-Attribute). */
export function sicheresHtml(html: string | null | undefined): string {
  if (!html) return "";
  const vorhanden = cache.get(html);
  if (vorhanden !== undefined) return vorhanden;
  const doc = new DOMParser().parseFromString(`<!doctype html><body><div>${html}</div></body>`, "text/html");
  const wurzel = doc.body.firstElementChild;
  if (!wurzel) return "";
  reinigen(wurzel);
  const ergebnis = wurzel.innerHTML;
  if (cache.size > 500) cache.clear();
  cache.set(html, ergebnis);
  return ergebnis;
}

export function istHtml(text: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(text);
}

function escape(text: string): string {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/** Klartext aus der Eingabe -> einfaches HTML (Absätze, Zeilenumbrüche). */
export function textZuHtml(text: string): string {
  return text
    .trim()
    .split(/\n{2,}/)
    .map((absatz) => `<p>${escape(absatz).replace(/\n/g, "<br/>")}</p>`)
    .join("");
}

/** HTML -> Klartext (für Bearbeiten und Vorschau). */
export function htmlZuText(html: string | null | undefined): string {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(
    `<!doctype html><body>${html.replace(/<br\s*\/?>/gi, "\n").replace(/<\/(p|div|li|h[1-6]|blockquote)>/gi, "\n\n")}</body>`,
    "text/html",
  );
  return (doc.body.textContent ?? "").replace(/\n{3,}/g, "\n\n").trim();
}

/** Enthält das HTML mehr als Absätze und Umbrüche (geht beim Bearbeiten als Klartext Formatierung verloren)? */
export function hatFormatierung(html: string | null | undefined): boolean {
  if (!html) return false;
  return /<(?!\/?(p|br|div)\b)[a-z]/i.test(html);
}
